import { objectSchema } from "vue-utils"
import type { INamed, IncidentEntity } from "../IncidentEntity"

export interface VtsCorrespondent extends IncidentEntity, INamed {}

export const VtsCorrespondent = objectSchema<VtsCorrespondent>({
	id: Number,
	name: String,
})
